import { IoIosArrowBack } from "react-icons/io"
import { useNavigate } from "react-router"

export const BackButton = () => {
  const navigate = useNavigate()
  const navigateBack = () => {
    navigate(-1)
  }

  return <button className="btn btn-ghost btn-outline text-[#a8acb5] border-[#a8acb5] px-3" onClick={navigateBack}>
    <IoIosArrowBack />
  </button>
}

interface BreadCrumbProps {
  children?: React.ReactNode
}

const BreadCrumb = ({ children }: BreadCrumbProps) => {
  return <div className="flex gap-4 items-center text-[#282828]">
    <BackButton />
    <div className="font-semibold text-lg">
      {
        children
      }
    </div>
  </div>
}

export default BreadCrumb

